import { render } from "./NewInfo.vue?vue&type=template&id=f1ca85aa&scoped=true"
import script from "./NewInfo.vue?vue&type=script&lang=js"
export * from "./NewInfo.vue?vue&type=script&lang=js"

import "./NewInfo.vue?vue&type=style&index=0&id=f1ca85aa&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ca85aa"]])

export default __exports__